import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { CatalogService } from '../../../services/catalog.service';
import { BODY_TYME, LIVING_ENVIROMENT, LIFESTYLE, TEMPERAMENT, HOUSEHOLD_POPULATION, OTHER_PETS, COAT_CONDITION, MENTAL_CONDITION, TYPE_EXERCISE, FRECUENCY_EXERCISE, DURATION_EXERCISE, ECO_PARASITES, TRAINING, CLIMATE, TRAINING_PROFICIENCY } from '../../../../environments/environment';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'ngx-work-profile-envment',
  templateUrl: './profile-envment.component.html',
})
export class ProfileEnvmentComponent implements OnInit {

  private _pet_no: number;
  BODY_TYME = BODY_TYME;
  LIVING_ENVIROMENT = LIVING_ENVIROMENT;
  LIFESTYLE = LIFESTYLE;
  TEMPERAMENT = TEMPERAMENT;
  HOUSEHOLD_POPULATION = HOUSEHOLD_POPULATION;
  OTHER_PETS = OTHER_PETS;
  COAT_CONDITION = COAT_CONDITION;
  MENTAL_CONDITION = MENTAL_CONDITION;
  TYPE_EXERCISE = TYPE_EXERCISE;
  FRECUENCY_EXERCISE = FRECUENCY_EXERCISE;
  DURATION_EXERCISE = DURATION_EXERCISE;
  ECO_PARASITES = ECO_PARASITES;
  TRAINING = TRAINING;
  TRAINING_PROFICIENCY = TRAINING_PROFICIENCY;
  CLIMATE = CLIMATE;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.petService.getEnvironmentByPetId(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    public catalogService: CatalogService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
      });
  }

  save() {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    this.petService.setupPetEnvironment()
        .then(() => {
            Swal.close();

            Swal.fire({
              title: 'Information stored correctly',
              didOpen: () => {
              },
            })
        });
  }

}
